(function () {
  // Starter-Lebensmitteldatenbank (Naeherungswerte je 100 g)
  // [name,kcal,Eiweiss,KH,Fett,Ballaststoffe,Magnesium(mg),Eisen(mg),Calcium(mg),Zink(mg),VitC(mg),VitD(ug),B12(ug),Folat(ug),Omega3(g)]
  var DB = [
    ["Haferflocken",370,13.5,59,7,10,140,4.7,54,4,0,0,0,32,0.1],["Vollkornbrot",250,9,45,3.5,7,90,2.5,40,1.8,0,0,0,20,0.05],
    ["Reis (gekocht)",130,2.7,28,0.3,0.4,12,0.2,10,0.5,0,0,0,3,0],["Vollkornnudeln (gekocht)",150,6,30,1.5,4,40,1.3,15,1,0,0,0,8,0],
    ["Quinoa (gekocht)",120,4.4,21,1.9,2.8,64,1.5,17,1.1,0,0,0,42,0.08],["Linsen (gekocht)",116,9,20,0.4,8,36,3.3,19,1.3,1.5,0,0,180,0.1],
    ["Kichererbsen (gekocht)",164,8.9,27,2.6,7.6,48,2.9,49,1.5,1.3,0,0,172,0.05],["Kidneybohnen (gekocht)",127,8.7,23,0.5,7.4,45,2.9,35,1,1.2,0,0,130,0.1],
    ["Tofu",144,15,3,9,2,58,2.7,350,2,0.1,0,0,19,0.6],["Edamame",121,11,9,5,5,61,2.3,63,1.3,6,0,0,300,0.36],
    ["Brokkoli",34,2.8,7,0.4,2.6,21,0.7,47,0.4,89,0,0,63,0.1],["Spinat",23,2.9,3.6,0.4,2.2,79,2.7,99,0.5,28,0,0,194,0.14],
    ["Grünkohl",49,4.3,9,0.9,3.6,47,1.6,150,0.4,120,0,0,141,0.18],["Möhre",41,0.9,10,0.2,2.8,12,0.3,33,0.2,6,0,0,19,0],
    ["Paprika (rot)",31,1,6,0.3,2.1,12,0.4,7,0.25,128,0,0,46,0],["Tomate",18,0.9,3.9,0.2,1.2,11,0.3,10,0.17,14,0,0,15,0],
    ["Kartoffel (gekocht)",87,2,20,0.1,1.8,22,0.3,5,0.3,13,0,0,10,0],["Süßkartoffel",86,1.6,20,0.1,3,25,0.6,30,0.3,2.4,0,0,11,0],
    ["Zucchini",17,1.2,3.1,0.3,1,18,0.4,16,0.3,18,0,0,24,0],["Champignon",22,3.1,3.3,0.3,1,9,0.5,3,0.5,2,0.2,0,17,0],
    ["Banane",89,1.1,23,0.3,2.6,27,0.3,5,0.15,8.7,0,0,20,0],["Apfel",52,0.3,14,0.2,2.4,5,0.1,6,0.04,4.6,0,0,3,0],
    ["Orange",47,0.9,12,0.1,2.4,10,0.1,40,0.07,53,0,0,30,0],["Beeren (gemischt)",45,1,10,0.4,3,18,0.5,20,0.3,30,0,0,25,0.05],
    ["Avocado",160,2,9,15,7,29,0.6,12,0.6,10,0,0,81,0.11],["Kiwi",61,1.1,15,0.5,3,17,0.3,34,0.14,93,0,0,25,0.04],
    ["Mandeln",579,21,22,50,12.5,270,3.7,269,3.1,0,0,0,44,0],["Walnüsse",654,15,14,65,6.7,158,2.9,98,3.1,1.3,0,0,98,9],
    ["Kürbiskerne",559,30,11,49,6,592,8.8,46,7.8,1.9,0,0,58,0.12],["Chiasamen",486,17,42,31,34,335,7.7,631,4.6,1.6,0,0,49,17.8],
    ["Leinsamen",534,18,29,42,27,392,5.7,255,4.3,0.6,0,0,87,22.8],["Sonnenblumenkerne",584,21,20,51,8.6,325,5.2,78,5,1.4,0,0,227,0.07],
    ["Erdnussbutter",588,25,20,50,6,154,1.9,49,2.9,0,0,0,87,0],["Naturjoghurt",61,3.5,4.7,3.3,0,12,0.05,121,0.6,0.5,0.1,0.4,7,0],
    ["Skyr",63,11,4,0.2,0,11,0.05,150,0.5,0,0.1,0.4,7,0],["Gouda (Käse)",356,25,2.2,27,0,29,0.1,700,3.9,0,0.5,1.5,21,0],
    ["Milch",64,3.4,4.8,3.6,0,11,0.03,120,0.4,0,0.1,0.5,5,0],["Haferdrink",45,0.8,7,1.5,0.8,12,0.2,120,0.1,0,1.1,0.4,0,0.05],
    ["Kefir",65,3.8,4.5,3.5,0,12,0.05,120,0.5,0.9,0.1,0.4,8,0],["Hähnchenbrust",165,31,0,3.6,0,29,0.7,15,1,0,0.1,0.3,4,0.03],
    ["Rindfleisch (mager)",187,26,0,9,0,21,2.6,18,4.8,0,0.1,2.6,7,0.05],["Lachs",208,20,0,13,0,29,0.8,12,0.6,0,11,3.2,26,2.3],
    ["Thunfisch",132,28,0,1,0,50,1.3,8,0.6,0,2,9,2,0.3],["Ei",155,13,1.1,11,0,12,1.8,56,1.3,0,2,1.1,47,0.1],
    ["Makrele",205,19,0,14,0,76,1.6,12,0.6,0,16,8.7,1,2.6],["Garnelen",99,24,0.2,0.3,0,37,0.5,70,1.6,0,0.1,1.5,46,0.5],
    ["Dunkle Schokolade 85%",600,10,30,46,11,228,11,73,3.3,0,0,0,25,0.1],["Olivenöl",884,0,0,100,0,0,0.6,1,0,0,0,0,0,0.76],
    ["Hummus",166,8,14,10,6,71,2.4,38,1.4,0,0,0,83,0.1],["Sauerkraut",19,0.9,4,0.1,2.9,13,1.5,30,0.2,15,0,0,24,0],
    ["Porridge (gekocht)",71,2.5,12,1.5,1.7,27,0.9,10,0.7,0,0,0,6,0.02],["Erbsen",81,5.4,14,0.4,5,33,1.5,25,1.2,40,0,0,65,0],
    ["Rote Bete",43,1.6,10,0.2,2.8,23,0.8,16,0.35,4.9,0,0,109,0],["Petersilie",36,3,6,0.8,3.3,50,6.2,138,1.1,133,0,0,152,0.07]
  ];
  var KEYS=["kcal","p","c","f","fib","mg","fe","ca","zn","vc","vd","b12","fol","o3"];
  var TARGET={kcal:2000,p:55,c:260,f:70,fib:30,mg:350,fe:12,ca:1000,zn:9,vc:100,vd:20,b12:4,fol:300,o3:2};
  var UNIT={kcal:"kcal",p:"g",c:"g",f:"g",fib:"g",mg:"mg",fe:"mg",ca:"mg",zn:"mg",vc:"mg",vd:"µg",b12:"µg",fol:"µg",o3:"g"};
  var SHOWN=[["kcal","Kalorien"],["p","Eiweiß"],["fib","Ballaststoffe"],["mg","Magnesium"],["fe","Eisen"],["ca","Calcium"],["vc","Vitamin C"],["vd","Vitamin D"],["b12","Vitamin B12"],["o3","Omega-3"]];

  var PROD={
    mag:{n:"Magnesium-Komplex",p:"",u:"/collections/schlaf"},
    d3k2:{n:"Vitamin D3 + K2 Tropfen",p:"",u:"/collections/immunsystem"},
    o3:{n:"Omega-3",p:"",u:"/collections/all"},
    eisen:{n:"Eisen + Vitamin C",p:"",u:"/collections/energie"},
    ashwa:{n:"Ashwagandha",p:"",u:"/collections/schlaf"},
    kollagen:{n:"Kollagen",p:"",u:"/collections/haut-haare"},
    holunder:{n:"Holunder + Vitamin C + Zink",p:"",u:"/collections/immunsystem"},
    multi:{n:"Multivitamin + Mineralstoffe",p:"",u:"/collections/immunsystem"},
    darm:{n:"Mariendistel Komplex",p:"",u:"/collections/darm"}
  };

  function load(k,def){ try{ var v=localStorage.getItem(k); return v?JSON.parse(v):def; }catch(e){ return def; } }
  function save(k,v){ try{ localStorage.setItem(k,JSON.stringify(v)); }catch(e){} }
  var profile=load("pfDashProfile",null);
  var log=load("pfDashLog",{});
  function todayKey(){ var d=new Date(); return d.getFullYear()+"-"+("0"+(d.getMonth()+1)).slice(-2)+"-"+("0"+d.getDate()).slice(-2); }

  function rev(x){x=x%360;return x<0?x+360:x;} function sd(x){return Math.sin(x*Math.PI/180);} function cd(x){return Math.cos(x*Math.PI/180);}
  function moonToday(){ var t=new Date(),Y=t.getFullYear(),M=t.getMonth()+1,D=t.getDate();
    var d=367*Y-Math.floor(7*(Y+Math.floor((M+9)/12))/4)+Math.floor(275*M/9)+D-730530+0.5;
    var ws=282.9404+4.70935e-5*d,es=0.016709-1.151e-9*d,Ms=rev(356.0470+0.9856002585*d);
    var Es=Ms+es*(180/Math.PI)*sd(Ms)*(1+es*cd(Ms)),xs=cd(Es)-es,ys=Math.sqrt(1-es*es)*sd(Es);
    var vs=rev(Math.atan2(ys,xs)*180/Math.PI),lonsun=rev(vs+ws);
    var N=125.1228-0.0529538083*d,i=5.1454,w=318.0634+0.1643573223*d,e=0.0549,Mm=rev(115.3654+13.0649929509*d);
    var E=Mm+e*(180/Math.PI)*sd(Mm)*(1+e*cd(Mm)); for(var k=0;k<4;k++){E=E-(E-e*(180/Math.PI)*sd(E)-Mm)/(1-e*cd(E));}
    var x=cd(E)-e,y=Math.sqrt(1-e*e)*sd(E),r=Math.sqrt(x*x+y*y),v=rev(Math.atan2(y,x)*180/Math.PI);
    var xe=r*(cd(N)*cd(v+w)-sd(N)*sd(v+w)*cd(i)),ye=r*(sd(N)*cd(v+w)+cd(N)*sd(v+w)*cd(i));
    var lon=rev(Math.atan2(ye,xe)*180/Math.PI),Lm=rev(N+w+Mm),Ls=rev(ws+Ms),Dm=rev(Lm-Ls),F=rev(Lm-N);
    lon+=-1.274*sd(Mm-2*Dm)+0.658*sd(2*Dm)-0.186*sd(Ms)-0.059*sd(2*Mm-2*Dm)-0.057*sd(Mm-2*Dm+Ms)+0.053*sd(Mm+2*Dm)+0.046*sd(2*Dm-Ms)+0.041*sd(Mm-Ms)-0.035*sd(Dm)-0.031*sd(Mm+Ms)-0.015*sd(2*F-2*Dm)+0.011*sd(Mm-4*Dm);
    lon=rev(lon); var el=rev(lon-lonsun);
    var SIGN=[["Widder","Feuer"],["Stier","Erde"],["Zwillinge","Luft"],["Krebs","Wasser"],["Löwe","Feuer"],["Jungfrau","Erde"],["Waage","Luft"],["Skorpion","Wasser"],["Schütze","Feuer"],["Steinbock","Erde"],["Wassermann","Luft"],["Fische","Wasser"]];
    var TT={Feuer:"Fruchttag",Erde:"Wurzeltag",Luft:"Blütentag",Wasser:"Blatttag"};
    var s=SIGN[Math.floor(lon/30)%12];
    return {sign:s[0],type:TT[s[1]],waxing:el<180,illum:Math.round((1-cd(el))/2*100)};
  }

  var $=function(id){return document.getElementById(id);};

  function renderMoon(){ var m=moonToday();
    $("db-moon").innerHTML='<div style="font-size:17px;font-weight:600;color:#3a3a38;">'+m.type+'</div>'+
      '<div style="font-size:13px;color:#6b6b66;margin-top:3px;">Mond im '+m.sign+' · '+(m.waxing?"zunehmend":"abnehmend")+' · '+m.illum+'% beleuchtet</div>';
  }

  function renderProfileCard(){
    var body=$("db-profile-body"); if(!body) return;
    var goals=(profile&&profile.goals)||[]; var diet=(profile&&profile.diet)||"";
    if(!goals.length && !diet){
      body.innerHTML='<p class="db-hint" style="margin-bottom:13px;">Lege deine Ziele fest, damit wir passende Empfehlungen zeigen können.</p>'+
        '<button class="db-btn sec" id="db-goals-set">Ziele festlegen</button>';
      var b=$("db-goals-set"); if(b) b.addEventListener("click",function(){ openProfile(); });
      return;
    }
    var chips=goals.length?goals.map(function(g){ return '<span class="db-chip">'+g+'</span>'; }).join(""):'<span class="db-hint">Noch keine Ziele gewählt.</span>';
    body.innerHTML='<div style="margin-bottom:8px;">'+chips+'</div>'+
      (diet?'<div style="font-size:13px;color:#6b6b66;">Ernährungsform: <strong style="color:#3a3a38;">'+diet+'</strong></div>':'');
  }

  function totals(){ var t={}; KEYS.forEach(function(k){t[k]=0;});
    (log[todayKey()]||[]).forEach(function(e){ var factor=e.g/100; for(var i=0;i<KEYS.length;i++){ t[KEYS[i]]+=(e.v[i]||0)*factor; } });
    return t;
  }

  function renderEntries(){ var list=log[todayKey()]||[]; var el=$("db-entries");
    if(!list.length){ el.innerHTML='<p class="db-hint">Noch nichts erfasst. Such oben ein Lebensmittel.</p>'; return; }
    var kcal=0; var html="";
    list.forEach(function(e,idx){ var c=Math.round(e.v[0]*e.g/100); kcal+=c;
      html+='<div class="db-food-row"><span>'+e.n+' <span style="color:#6b6b66;">· '+e.g+' g</span></span><span>'+c+' kcal <button data-i="'+idx+'" class="db-del">✕</button></span></div>';
    });
    html+='<div style="text-align:right;font-weight:600;color:#3a3a38;margin-top:8px;">Summe: '+Math.round(kcal)+' kcal</div>';
    el.innerHTML=html;
    el.querySelectorAll(".db-del").forEach(function(btn){ btn.addEventListener("click",function(){ var i=+this.getAttribute("data-i"); list.splice(i,1); log[todayKey()]=list; save("pfDashLog",log); renderAll(); }); });
  }

  function renderBars(){ var t=totals(); var html="";
    SHOWN.forEach(function(s){ var k=s[0]; var val=t[k]; var tar=TARGET[k]; var pct=Math.round(val/tar*100);
      var w=Math.min(pct,100); var cls=pct<40?"low":(pct<70?"warn":"");
      html+='<div class="db-bar"><div class="lab"><span>'+s[1]+'</span><span>'+Math.round(val)+' / '+tar+' '+UNIT[k]+' ('+pct+'%)</span></div><div class="track"><div class="fill '+cls+'" style="width:'+w+'%;"></div></div></div>';
    });
    $("db-bars").innerHTML=html;
  }

  function renderRecs(){ var t=totals(); var picks=[]; var seen={};
    function add(key,reason){ if(!key||seen[key])return; seen[key]=1; picks.push({p:PROD[key],r:reason}); }
    var hasLog=(log[todayKey()]||[]).length>0;
    if(hasLog){
      if(t.mg/TARGET.mg<0.6) add("mag","Deine Magnesium-Zufuhr ist heute noch niedrig.");
      if(t.vd/TARGET.vd<0.6) add("d3k2","Vitamin D wird über Lebensmittel selten gedeckt.");
      if(t.o3/TARGET.o3<0.6) add("o3","Wenig Omega-3 heute — eine pflanzliche Quelle kann helfen.");
      if(t.fe/TARGET.fe<0.6) add("eisen","Deine Eisen-Zufuhr könnte höher sein.");
      if(t.b12/TARGET.b12<0.6) add("multi","Vitamin B12 ist heute niedrig.");
    }
    var g=(profile&&profile.goals)||[];
    if(g.indexOf("Schlaf")>=0){add("mag","Passend zu deinem Ziel Schlaf.");add("ashwa","Adaptogen bei Anspannung.");}
    if(g.indexOf("Stress")>=0){add("ashwa","Passend zu deinem Ziel Stress.");add("mag","Magnesium bei Anspannung.");}
    if(g.indexOf("Immunsystem")>=0){add("d3k2","Passend zu deinem Ziel Immunsystem.");add("holunder","Holunder + C + Zink.");}
    if(g.indexOf("Sport")>=0){add("mag","Für Muskelfunktion beim Sport.");add("eisen","Eisen für aktive Menschen.");}
    if(g.indexOf("Energie")>=0){add("eisen","Passend zu deinem Ziel Energie.");add("multi","Rundum-Basis.");}
    if(g.indexOf("Haut & Haare")>=0){add("kollagen","Passend zu deinem Ziel Haut & Haare.");}
    if(g.indexOf("Darm")>=0){add("darm","Traditionelle Bitterstoffe für die Verdauung.");}
    var diet=(profile&&profile.diet)||"";
    if(diet==="Vegan"){add("o3","Pflanzliches Omega-3 für vegane Ernährung.");add("multi","B12 ist bei veganer Ernährung wichtig.");}
    if(!picks.length){ $("db-recs").innerHTML='<p class="db-hint">Wähle Ziele im Profil oder erfasse Mahlzeiten — dann erscheinen hier passende Empfehlungen.</p>'; return; }
    $("db-recs").innerHTML=picks.slice(0,4).map(function(x){
      return '<div class="db-rec"><div class="thumb">Foto</div><div class="g"><a href="'+x.p.u+'">'+x.p.n+'</a><p>'+x.r+'</p><span class="pr">'+x.p.p+'</span></div></div>';
    }).join("");
  }

  function renderGreet(){ $("db-greet").textContent=(profile&&profile.name)?("Hallo "+profile.name):"Willkommen"; }

  function renderAll(){ renderGreet(); renderMoon(); renderProfileCard(); renderEntries(); renderBars(); renderRecs(); }

  var picked=null, curQuery="", searchTimer=null;

  function pickFood(food){ picked=food; $("db-pick-name").textContent=food.n; $("db-add-row").style.display="flex"; $("db-results").style.display="none"; $("db-search").value=food.n; $("db-grams").focus(); }

  function addResult(res,label,meta,food){
    var d=document.createElement("div");
    d.innerHTML=label+' <span style="color:#6b6b66;font-size:12px;">'+meta+'</span>';
    d.addEventListener("click",function(){ pickFood(food); });
    res.appendChild(d);
  }

  function offToFood(p){
    var nu=p.nutriments||{};
    function g(k){ var v=nu[k]; return (typeof v==="number" && !isNaN(v))?v:0; }
    var kcal=g("energy-kcal_100g")||g("energy-kcal")||0;
    var name=(p.product_name||"").trim();
    if(p.brands){ name+=" ("+String(p.brands).split(",")[0].trim()+")"; }
    var folat=(nu["vitamin-b9_100g"]!=null?g("vitamin-b9_100g"):g("folates_100g"));
    var arr=[ kcal, g("proteins_100g"), g("carbohydrates_100g"), g("fat_100g"), g("fiber_100g"),
      g("magnesium_100g")*1000, g("iron_100g")*1000, g("calcium_100g")*1000, g("zinc_100g")*1000,
      g("vitamin-c_100g")*1000, g("vitamin-d_100g")*1e6, g("vitamin-b12_100g")*1e6, folat*1e6, g("omega-3-fat_100g") ];
    return { n:(name||"Produkt"), v:arr, kcal:kcal };
  }

  function fetchOFF(query,res){
    var q=query.trim(); var isBarcode=/^[0-9]{8,14}$/.test(q);
    var url=isBarcode
      ? "https://world.openfoodfacts.org/api/v2/product/"+q+".json?fields=product_name,brands,nutriments"
      : "https://world.openfoodfacts.org/cgi/search.pl?search_terms="+encodeURIComponent(q)+"&search_simple=1&action=process&json=1&page_size=10&fields=product_name,brands,nutriments";
    fetch(url).then(function(r){return r.json();}).then(function(data){
      if(curQuery!==query) return;
      var prods=isBarcode?(data.product?[data.product]:[]):(data.products||[]);
      var added=0;
      prods.forEach(function(p){
        if(added>=8) return;
        var nu=p.nutriments||{};
        if(!p.product_name || (nu["energy-kcal_100g"]==null && nu["energy-kcal"]==null)) return;
        var food=offToFood(p);
        addResult(res, food.n, Math.round(food.kcal)+" kcal/100g · Online", food);
        added++;
      });
      res.style.display=(res.children.length?"block":"none");
    }).catch(function(){});
  }

  function renderResults(query){
    var res=$("db-results"); res.innerHTML="";
    var ql=query.toLowerCase();
    DB.filter(function(r){ return r[0].toLowerCase().indexOf(ql)>=0; }).slice(0,6).forEach(function(r){
      addResult(res, r[0], r[1]+" kcal/100g · Basis", {n:r[0], v:r.slice(1)});
    });
    var hint=document.createElement("div"); hint.style.cssText="color:#6b6b66;font-size:12px;cursor:default;"; hint.textContent="Suche online über Open Food Facts…"; res.appendChild(hint);
    res.style.display="block";
    fetchOFF(query,res);
  }

  $("db-search").addEventListener("input",function(){
    var q=this.value.trim(); curQuery=q; var res=$("db-results");
    if(q.length<2){ res.style.display="none"; return; }
    clearTimeout(searchTimer);
    searchTimer=setTimeout(function(){ if(curQuery===q) renderResults(q); }, 300);
  });
  document.addEventListener("click",function(e){ if(!e.target.closest(".db-search-wrap")) { var r=$("db-results"); if(r) r.style.display="none"; } });

  $("db-add").addEventListener("click",function(){ if(!picked)return; var g=parseInt($("db-grams").value,10)||100;
    var list=log[todayKey()]||[]; list.push({n:picked.n,g:g,v:picked.v}); log[todayKey()]=list; save("pfDashLog",log);
    picked=null; $("db-search").value=""; $("db-add-row").style.display="none"; renderAll();
  });

  var tmpGoals=[];
  function openProfile(){ var ov=$("db-overlay");
    $("pf-name").value=(profile&&profile.name)||""; $("pf-gender").value=(profile&&profile.gender)||"";
    $("pf-diet").value=(profile&&profile.diet)||"Omnivor"; tmpGoals=(profile&&profile.goals?profile.goals.slice():[]);
    document.querySelectorAll("#pf-goals .db-goal").forEach(function(el){ el.classList.toggle("on",tmpGoals.indexOf(el.getAttribute("data-g"))>=0); });
    ov.classList.add("open");
  }
  document.querySelectorAll("#pf-goals .db-goal").forEach(function(el){ el.addEventListener("click",function(){ var g=this.getAttribute("data-g"); var i=tmpGoals.indexOf(g); if(i>=0)tmpGoals.splice(i,1); else tmpGoals.push(g); this.classList.toggle("on"); }); });
  $("pf-save").addEventListener("click",function(){
    profile={ name:$("pf-name").value.trim(), gender:$("pf-gender").value, goals:tmpGoals.slice(), diet:$("pf-diet").value };
    save("pfDashProfile",profile); $("db-overlay").classList.remove("open"); renderAll();
  });
  $("pf-cancel").addEventListener("click",function(){ $("db-overlay").classList.remove("open"); });
  $("db-overlay").addEventListener("click",function(e){ if(e.target===this) this.classList.remove("open"); });
  $("db-edit").addEventListener("click",function(){ openProfile(); });

  renderAll();
})();
